<template>
    <BaseModal :title="title" :width="360" v-model="show">
        <a-alert :show-icon="true" style="margin-bottom: 10px;" type="warning">
            <template #message>请选择要{{title}}的子相册，可多选</template>
        </a-alert>
        <div v-if="options.length">
            <a-checkbox-group v-model="folder_id">
                <div :key="index" style="margin: 10px 0;" v-for="(opt, index) in options">
                    <a-checkbox :value="opt.value">{{opt.label}}</a-checkbox>
                </div>
            </a-checkbox-group>
            <div style="width: 100%; text-align: center; padding-top: 20px;">
                <a-button :disabled="!folder_id.length" @click="submit" icon="check" type="primary">提交{{title}}</a-button>
            </div>
        </div>
        <a-empty v-else description="暂无子相册，请先创建" style="margin-top: 20px;"/>
    </BaseModal>
</template>

<script>
    import api from "../../../../../utils/api";
    import cache from "../../../../../utils/cache";
    import BaseModal from "../../../../../comps/BaseModal";

    export default {
        name: "FolderSelect",
        components: {BaseModal},
        props: {albumId: String},
        data() {
            return {
                show: false,
                title: "",
                options: [],
                effect: false,
                selected: [],
                folder_id: [],
            }
        },
        mounted() {
            cache.v1.album.folder.option(this.albumId)
                .then(res => this.options = res);
        },
        methods: {
            open(selected, effect, message, folderId) {
                this.show = true;
                this.title = message;
                this.effect = effect;
                this.selected = selected;
                this.folder_id = folderId ? [folderId] : [];
            },
            submit() {
                let promise = this.effect
                    ? api.v1.album.photo.link(this.albumId, this.selected, this.folder_id)
                    : api.v1.album.photo.unlink(this.albumId, this.selected, this.folder_id);
                return promise
                    .then(() => {
                        this.show = false;
                        this.$emit("saved");
                        this.$message.success(`${this.title}成功`);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$message.error(`${this.title}失败`);
                    });
            }
        }
    }
</script>
